// extracted by mini-css-extract-plugin
export default {"dataTable":"data-table_dataTable__X4T2w"};